export default __webpack_public_path__ + "static/media/demo.0b61c8e3.png";